import React, { Component } from 'react';
import { ImQuotesLeft, ImQuotesRight } from 'react-icons/im';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './index.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

class Carousel extends Component {
    render() {
        return (
                <div className="carousel-container">
                    <div data-aos="fade-up" data-aos-duration="1500">
                        <h2>Testimonials</h2>
                        <div className="divider" />
                        <h5>The best only hire the brightest.</h5>
                    </div>
                    <div data-aos="fade-up" data-aos-duration="2000" className="slider-container">
                        <div>
                            <div className="image-container">
                                <img src="/images/user-3.png" alt="" />
                            </div>
                            <div className="slider-item">
                                <p><ImQuotesLeft className="quotes"/> Foam solutions made it extremely easy to book an appointment to make sure we where compliant. They went above and beyond in fixing all of the issues we had, and made sure we knew how to stay compliant! <ImQuotesRight className="quotes" /></p>
                                <h3>Steven Baldwin</h3>
                                <h5 className="business-title">Business Owner</h5>
                            </div>
                        </div>
                        <div className="item-container">
                            <div className="image-container">
                            <img src="/images/persona.svg" alt="" />
                                
                            </div>
                            <div className="slider-item">
                                <p><ImQuotesLeft className="quotes" /> The Navistar Assembly Plant in Springfield, Ohio contracts Foam Solutions to test our fire protection systems. The employees at Foam Solutions are experts in their field and keep our Assembly Plant, Paint Facility and Truck Specialty Center in... <ImQuotesRight className="quotes" /></p>
                                <div>
                                    <h3>Rusty</h3>
                                    <h5 className="business-title">Business Associate</h5>
                                </div>
                            </div>
                        </div>
                        <div className="item-container">
                            <div className="image-container">
                                <img src="/images/user-ricky.png" alt="" />
                            </div>
                            <div className="slider-item"> 
                                <p><ImQuotesLeft className="quotes" /> We contract foam solutions to come in and test our foam proportioner system to hopefully cut down on the cost of a regular foam test. We are happy to say it was much cheaper, and they did an amazing job! <ImQuotesRight className="quotes" /></p>
                                <h3>Kris Young</h3>
                                <h5 className="business-title">Business Associate</h5>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}
export default Carousel;